export const LEADS_MANAGE_TABS = ['All leads', 'Pending', 'Auto Priced', 'Assigned To Me', 'Part Exchange', 'Trade', 'Scrap'];
export const LEADS_MANAGE_LEADOMATIC_TABS = ['All leads', 'Pending', 'Auto Priced', 'Assigned To Me'];

export const INITIAL_FILTERS_LEAD_MANAGE = {
    is_manager_special: false,
    ref_lead_status: undefined,
    ref_lead_source: undefined,
    ref_assigned_to: undefined,
    ref_lead_affiliate: undefined,
    dateFrom: undefined,
    dateTo: undefined,
    vrm: '',
    ref_bike_brand: undefined,
    ref_bike_model: undefined,
    hideDuplicate: false,
    is_part_ex: undefined,
    customer: undefined,
    post_code: undefined,
    hide_leadomatic_leads: false,
    is_hot: false,
    is_trade: false,
    mileageFrom: undefined,
    mileageTo: undefined,
    yearFrom: undefined,
    yearTo: undefined,
    valuationFrom: undefined,
    valuationTo: undefined,
    marginFrom: undefined,
    marginTo: undefined,
    rag_rating: undefined,
    sortField: 'created_date',
    sortDirection: -1,
};

export const INITIAL_PAGINATION_LEAD_MANAGE = {
    page: 0,
    rows_per_page: 100,
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/contants/filter.constants.js